module.exports = __webpack_public_path__ + "static/media/icon_valadd.5fdf8296.svg";